import { useAuth } from "../providers/Auth";

import { ValidationCodes } from "@/generated/graphql";

/**
 * Hook that returns validation codes for the current user from AuthProvider
 *
 * Reads validationCodes from the AuthProvider context which were set during
 * the confirmSignIn flow. Returns undefined if user is not logged in.
 * @returns Array of validation codes if user is logged in, undefined otherwise
 */
const useUserValidationCodes = (): readonly ValidationCodes[] | undefined => {
  const auth = useAuth();

  if (!auth?.isLoggedIn) {
    return undefined;
  }

  return auth.validationCodes;
};

export default useUserValidationCodes;
